import Store from '../store';
import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';

export default {

    computed: {
        ...mapState('ProjectManager', [
            'projects',
            'projectsLoading',
        ]),
    },

    methods: {
        ...mapActions('ProjectManager', [
            'loadProjects',
        ]),
    },

    created() {
        if (!this.$store.state.ProjectManager) {
            this.$store.registerModule('ProjectManager', Store);
        }

        if (this.hasPermission('view projects')) {
            this.loadProjects({force: false});
        }
    },
};

